// extracted by mini-css-extract-plugin
export default {"overlayContainer":"styles_overlayContainer__DJjzn"};